import { ConfUIItem } from "./confUIItem";

export class GroupConfUIItem extends ConfUIItem {
    
  protected readonly GROUP_ITEM_NAME = "groupItemName";

  get groupItemName(): string { return this.getInternalValue<string>(this.GROUP_ITEM_NAME); }
  setGroupItemName(groupItemName: string): this { return this.setInternalValue(this.GROUP_ITEM_NAME, groupItemName); }
}